module.exports = "<body class=\"app header-fixed sidebar-fixed aside-menu-hidden\" [ngClass]=\"{'sidebar-hidden': sidebarClosed}\">\n  <router-outlet name=\"header\"></router-outlet>\n\n  <div class=\"app-body\">\n    <router-outlet name=\"sidebar\"></router-outlet>\n    <main class=\"main\">\n      <div class=\"container-fluid\" style=\"padding: 10px !important;\">\n        <router-outlet></router-outlet>\n      </div>\n    </main>\n  </div>\n  <router-outlet name=\"popup\"></router-outlet>\n  <router-outlet name=\"footer\"></router-outlet>\n</body>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/main/main.component.html
// module id = 1134
// module chunks = 1